import { useTheme } from "@material-ui/styles";
import {
  StoryblokComponent,
  useEditableProps,
  useStoryblokEditable
} from "@sb-konzept/gatsby-source-storyblok";
import Box from "components/Box";
import * as R from "ramda";
import React, { useCallback, useReducer } from "react";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

function SlideContainer({ tab, dir }) {
  const editableProps = useEditableProps(tab)

  return (
    <Box dir={dir} {...editableProps} height="100%" position="relative">
      <StoryblokComponent key={tab.id || tab._uid} content={tab} />
    </Box>
  )
}

const initialState = {
  activeSlide: 0
}

function reducer(state, action) {
  switch (action.type) {
    case 'set-slide':
      return {
        ...state,
        activeSlide: action.activeSlide
      }
    case 'next-slide':
      return {
        ...state,
        activeSlide: state.activeSlide + 1
      }
    case 'previous-slide':
      return {
        ...state,
        activeSlide: state.activeSlide - 1
      }
    case 'reset':
      return initialState
    default:
      throw new Error(
        `StoryblokHeader: Reducer called with invalid action ${action.type}`
      )
  }
}

const AutoplayingSwipableViews = autoPlay(SwipeableViews)

function StoryblokHeader(props) {
  const { content } = props
  const { carouselSlides, geschwindigkeit } = content
  const theme = useTheme()
  const { editableProps } = useStoryblokEditable()
  const [{ activeSlide }, dispatch] = useReducer(reducer, initialState)

  function handleChangeIndex(index) {
    dispatch({ type: 'set-slide', activeSlide: index })
  }

  const actualSlide = R.mathMod(activeSlide, carouselSlides.length)

  return (
    <Box {...editableProps}>
      <Box display="flex">
        <Box
          as={AutoplayingSwipableViews}
          {...{
            interval: geschwindigkeit * 1000 || 3000,
            direction: "incremental"
          }}
          enableMouseEvents
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          containerStyle={{
            position: "relative",
            height: "max-content"
          }}
          index={actualSlide}
          slideStyle={{
            overflow: "hidden"
          }}
          width="100%"
          onChangeIndex={handleChangeIndex}
        >
          {carouselSlides.map((tab) => (
            <SlideContainer
              key={tab.id || tab._uid}
              dir={theme.direction}
              tab={tab}
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default React.memo(StoryblokHeader)
